<script>
    import HeaderBar from "../../../components/header/HeaderBar.svelte";
    import { _ } from "svelte-i18n";
    import { getLivestream } from "../../../content/data/livestreams";
    import { formatTime } from "../../../util/date";
    import YouTube from "svelte-youtube";
    import GeneralLayout from "../../../common/GeneralLayout.svelte";
    import LoadingSquare from "../../../common/LoadingSquare.svelte";

    const headerAction = "SHARE";
    const playerOptions = {
        height: "100%",
        width: "100%",
        //  see https://developers.google.com/youtube/player_parameters
        playerVars: {
            autoplay: 1, // start playing on load
            mute: 1, // mute on load to make autoplay work
        },
    };

    export let params = {};

    $: stream = getLivestream(params.id).then((stream) => {
        livechatSource =
            "https://www.youtube.com/live_chat?v=" +
            stream.videoId +
            "&embed_domain=" +
            window.location.hostname;
        console.log(stream);
        return stream;
    });

    $: livechatSource = stream;
    $: isLive = true;

    let player,
        playing = false;

    function onReady(event) {
        player = event.detail.target;
        console.log("player ready");
        console.log(event);
    }

    function onStateChange(event) {
        console.log(event);

        if (event.detail.data == 1) {
            playing = true;
            isLive = true;
            console.log("program is live");

            /// unmute after autoplay has started
            /// this gets blocked sometimes if the user has not interacted with the page yet
            //player.unMute();
        } else if (event.detail.data == 2) {
            playing = false;
            console.log("player is paused");
        } else {
            isLive = false;
            playing = false;
            console.log("program is not live");
        }
    }

    function onShare() {
        console.log("share");
    }
</script>

{#await stream}
    <LoadingSquare />
{:then stream}
    <div class="mobile-only">
        <HeaderBar
            showTitleAlways="true"
            title={stream.title ?? $_("livestream_title")}
            share={headerAction === "SHARE"}
        />
    </div>

    <GeneralLayout expand>
        <div slot="firstSegment" class="desktop-only" style="width: 100%;">
            <div class="desktop-only">
                <HeaderBar
                    on:actionClicked={onShare}
                    hideSeperator
                    close={headerAction === "CLOSE"}
                />
            </div>
            <div class="headline-m">{stream.title}</div>
        </div>
        <div slot="secondSegment" class="second-segment">
            <div class="video-wrapper">
                <YouTube
                    videoId={stream.videoId}
                    id="video"
                    class="video"
                    style="height: 100%;"
                    options={playerOptions}
                    on:ready={onReady}
                    on:stateChange={onStateChange}
                />

                <div
                    class="placeholder blur"
                    class:invisible={isLive}
                    style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px;"
                >
                    <div class="column" style="flex: 2.5;">
                        <div />
                        <div style="width: 100%;">
                            <div class="divider-h divider" />
                            <div class="headline-m stream-title">
                                {stream.title}
                            </div>
                        </div>
                    </div>
                    <div
                        class="divider-v"
                        style="margin: 8px 0; height: auto;"
                    />
                    <div class="column" style="flex: 1;">
                        <div class="time-indicator">
                            <div class="headline-m stream-title">
                                {#if stream.startDate}
                                    {formatTime(stream.startDate)}
                                {/if}
                            </div>
                            <div class="text-l stream-text">LIVE</div>
                            <div class="divider-h divider" />
                        </div>
                        <div class="text-l stream-text">
                            {#if (stream.startDate ?? Date.now()) < Date.now()}
                                {$_("livestream_over")}
                            {:else}
                                {$_("livestream_soon")}
                            {/if}
                        </div>
                    </div>
                </div>
            </div>

            <div class="livechat">
                {#await livechatSource}
                    <LoadingSquare />
                {:then livechatSource}
                    <iframe
                        title="Livechat"
                        style="border-width: 0"
                        width="100%"
                        height="100%"
                        src={livechatSource}
                    />
                {:catch}
                    <div class="error">
                        <span class="text-l" style="font-size: 24px;">
                            {$_("entity_load_error")}
                        </span>
                    </div>
                {/await}
            </div>
        </div>
    </GeneralLayout>
{:catch e}
    <div class="error">
        <span class="text-l" style="font-size: 24px;">
            {$_("entity_load_error")}
        </span>
    </div>
{/await}

<style>
    .placeholder {
        background-color: #fff;
        height: 218px;
        width: 100%;

        display: flex;
        flex-direction: row;
    }

    .blur {
        -webkit-backdrop-filter: blur(24px);
        backdrop-filter: blur(24px);
        background: var(--white-64);
    }

    .column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;
        flex-grow: 1;
        padding: 8px;
    }

    .divider {
        margin: 8px 0;
    }

    .time-indicator {
        display: flex;
        flex-direction: column;
        align-items: start;
        width: 100%;
    }

    .invisible {
        display: none;
    }

    :global(.video) {
        position: absolute;
        left: 0px;
        right: 0px;
        top: 0px;
        bottom: 0px;
        height: 218px;
    }

    .second-segment {
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .video-wrapper {
        position: relative;
        height: 218px;
        width: 100%;
    }

    .livechat {
        height: 100%;
        width: 100%;
        flex-grow: 1;
        /* margin-bottom: 64px; */
    }

    .desktop-only {
        display: none;
    }

    .mobile-only {
        display: block;
    }

    .stream-text {
        font-weight: 100;
        font-size: 24px;
    }

    @media (min-width: 480px) {
        :global(.video) {
            height: 240px;
        }

        .video-wrapper {
            height: 240px;
        }

        .placeholder {
            height: 240px;
        }
    }

    @media (min-width: 768px) {
        :global(.video) {
            height: 480px;
        }

        .video-wrapper {
            height: 480px;
        }

        .placeholder {
            height: 480px;
        }
    }

    @media (min-width: 1440px) {
        .desktop-only {
            display: block;
        }

        .mobile-only {
            display: none;
        }

        .placeholder {
            height: 576px;
        }

        .video-wrapper {
            height: 576px;
        }

        .livechat {
            padding-bottom: 32px;
        }

        .second-segment {
            padding: 0 16px;
            padding-top: 48px;
            height: calc(100% - 72px);
        }

        .stream-title {
            font-size: 80px;
        }

        .stream-text {
            font-weight: 100;
            font-size: 64px;
        }

        :global(.video) {
            height: 576px;
        }
    }
</style>
